enum ApiTags {
    Asset = "Asset"
}

export default ApiTags;
